import {createClient as createSupabaseJsClient} from '@supabase/supabase-js';
import {supabaseAuthOptions} from './auth.js';

export function createSupabaseClient(config,{createClient=createSupabaseJsClient}={}){
  const url=String(config?.supabaseUrl||'').trim();
  const publishableKey=String(config?.supabasePublishableKey||'').trim();
  if(!url)throw new Error('Dymistrz Supabase URL is not configured');
  if(!/^https:\/\//i.test(url))throw new Error('Dymistrz Supabase URL must use HTTPS');
  if(!publishableKey)throw new Error('Dymistrz Supabase publishable key is not configured');
  if(/service[_-]?role|secret/i.test(publishableKey))throw new Error('Privileged Supabase credentials are forbidden in the client');

  return createClient(url,publishableKey,{
    auth:supabaseAuthOptions(),
    global:{
      headers:{'x-application-name':'dymistrz'}
    }
  });
}
